import { compose, fromRenderProps } from 'recompose';

import ScrollElementContext from 'components/hocs/scrollElementContext';

const enhance = compose(
  fromRenderProps(ScrollElementContext.Consumer, (scrollElement) => ({
    scrollElement,
  }))
);

export default enhance;
